import { Directive, ElementRef, Input } from "@angular/core";
import { AbstractControl } from "@angular/forms";

@Directive({
    selector: '[appInputEmailConfirmation]',
    host: { 
        '(paste)': 'onPaste($event)',
        '(keydown)': 'onKeyDown($event)',
        '(drop)': 'onDrop($event)'
    }
})
export class InputEmailConfirmationDirective
{
    @Input('control') public control: AbstractControl;

    private elementRef: ElementRef;

    public constructor(elementRef: ElementRef)
    {
        this.elementRef = elementRef;
        this.setAttributes();
    }

    public onPaste(event: KeyboardEvent): void
    {
        event.preventDefault();
    }

    public onKeyDown(event: KeyboardEvent): void
    {
        if (event.key === ' ')
        {
            event.preventDefault();
        }
    }

    public onDrop(event: DragEvent): void
    {
        if(!this.control)
        {
            return;
        }

        setTimeout(() => {
            const pastedValue = this.elementRef.nativeElement.value;
            this.control.patchValue('');
            this.control.patchValue(pastedValue.replace(/ /g, ''));
        }, 0);
    }

    private setAttributes(): void
    {
        const element = this.elementRef.nativeElement;
        element.setAttribute('autocomplete', 'no');
        element.setAttribute('type', 'email');
        if(element.getAttribute('placeholder') == null)
        {
            element.setAttribute('placeholder', 'Bekræft din email adresse'); 
        }
    }
}
